import { Sequence } from "remotion";
import { Stage } from "../../coldcompute";
import { SCENE } from "./constants";
import {
  Scene01Hook,
  Scene02Split,
  Scene03Zero,
  Scene04Bug1,
  Scene05Bug2,
  Scene06Bug3,
  Scene07Bug4,
  Scene08Punch,
  Scene09Verdict,
  Scene10Lesson,
  Scene11Outro,
} from "./scenes";

export const EvalGateCouldntSee: React.FC = () => (
  <Stage>
    <Sequence from={SCENE.hook.start} durationInFrames={SCENE.hook.duration}>
      <Scene01Hook />
    </Sequence>
    <Sequence from={SCENE.split.start} durationInFrames={SCENE.split.duration}>
      <Scene02Split />
    </Sequence>
    <Sequence from={SCENE.zero.start} durationInFrames={SCENE.zero.duration}>
      <Scene03Zero />
    </Sequence>
    <Sequence from={SCENE.bug1.start} durationInFrames={SCENE.bug1.duration}>
      <Scene04Bug1 />
    </Sequence>
    <Sequence from={SCENE.bug2.start} durationInFrames={SCENE.bug2.duration}>
      <Scene05Bug2 />
    </Sequence>
    <Sequence from={SCENE.bug3.start} durationInFrames={SCENE.bug3.duration}>
      <Scene06Bug3 />
    </Sequence>
    <Sequence from={SCENE.bug4.start} durationInFrames={SCENE.bug4.duration}>
      <Scene07Bug4 />
    </Sequence>
    <Sequence from={SCENE.punch.start} durationInFrames={SCENE.punch.duration}>
      <Scene08Punch />
    </Sequence>
    <Sequence from={SCENE.verdict.start} durationInFrames={SCENE.verdict.duration}>
      <Scene09Verdict />
    </Sequence>
    <Sequence from={SCENE.lesson.start} durationInFrames={SCENE.lesson.duration}>
      <Scene10Lesson />
    </Sequence>
    <Sequence from={SCENE.outro.start} durationInFrames={SCENE.outro.duration}>
      <Scene11Outro />
    </Sequence>
    {/* <Audio src={staticFile("vo/eval-gate-couldnt-see.mp3")} /> — add a VO track here later */}
  </Stage>
);

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
